import React, { useState } from 'react';
import {
  useIonViewWillEnter,
  IonContent,
  IonGrid,
  IonRow,
  useIonToast,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonCol,
  IonButton,
  IonSlides,
  IonSlide,
  IonIcon,
  IonTabButton,
} from '@ionic/react';

import {
  time,
  logoWhatsapp as whatsapp,
  call,
  list,
  medkit,
  medkitOutline as rentalIcon,
  eyedropOutline as vaccineIcon,
  calendarClear,
  documentTextOutline,
  calendarNumber,
  chatbubbleEllipses,
  flaskOutline,
  journalOutline,
  logoFacebook,
  logoInstagram,
  globeOutline,
} from 'ionicons/icons';

import HomeHeader from '../components/Home/HomeHeader';
// import HomeImg from '../components/Home/HomeImg';
import CertEcommerce from '../components/Home/CertEcommerce';
import useOptions from '../hooks/Shared/useOptions';
import useShops from '../hooks/Home/useShops';
import FadeSlider from '../components/Home/FadeSlider';

import SystemResource from '../resources/System';
import FidelityCardService from '../services/fidelityCard';

import ShopsService from '../services/shops';
import ReservationsService from '../services/reservations';
import OrderService from '../services/order';
import ProfileService from '../services/profile';
import EventService from '../services/shopevent';

const HomePage = (props) => {
  const { loader, history, slot, fpsConfigs } = props;

  const [reservations, setReservations] = useState([]);
  const [orders, setOrders] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [card, setCard] = useState(null);
  const [events, setEvents] = useState([]);

  const [shops, selected, loadShops] = useShops();
  const [options, slides, loadOptions] = useOptions();
  const [present, dismiss] = useIonToast();

  const version = `${SystemResource.apiversion}-${process.env.REACT_APP_VERSION}`;
  const select_service = options?.select_service ? JSON.parse(options.select_service) : [];

  // Le ricette inviate dall'app sono attive per default: solo il valore '0' le disabilita
  const prescriptionsEnabled = options?.prescriptions !== '0';

  useIonViewWillEnter(() => {
    loader.current.show();
    loadOptions();
    loadShops();
    getReservation();
    getOrders();
    checkLoginStatus();
    fidelity();
    loadEvents();
    loader.current.dismiss();
  });

  const openCall = async () => {
    if (!!options?.call_number) {
      window.open(`tel:${options?.call_number}`, '_system');
    }
  };

  const fidelity = async () => {
    try {
      SystemResource.checkVersion();

      const { data: cardData } = await FidelityCardService.getMain();
      if (!!cardData?.id) setCard(cardData);
    } catch (error) {
      if (error.response?.status !== 401) console.error(error);
    }
  };

  const openChat = async () => {
    if (!!options?.whatsapp_number) {
      const whatsappText = options?.whatsapp_text ?? '';
      window.open(`https://wa.me/${options?.whatsapp_number}?text=${encodeURI(whatsappText)}`, '_system');
    }
  };

  const openFacebook = async () => {
    if (!!options?.facebook) {
      window.open(options.facebook, '_system');
    }
  };

  const openInstagram = async () => {
    if (!!options?.instagram) {
      window.open(options.instagram, '_system');
    }
  };

  const openWebsite = async () => {
    if (!!options?.site_url) {
      window.open(options.site_url, '_system');
    }
  };

  const saveShop = (val) => {
    const shop_id = { shop_id: val };

    const loadData = async () => {
      try {
        await ShopsService.update(shop_id);
        toast('Punto vendita aggiornato');
      } catch (error) {
        toast('Errore, non è stato possibile aggiornare il punto vendita associato');
      }
    };

    if (selected !== undefined && val !== selected) {
      loadData();
    }
  };

  const toast = (mess) =>
    present({
      buttons: [{ text: 'X', handler: () => dismiss() }],
      message: mess,
      duration: 1000,
    });

  const getReservation = async () => {
    try {
      const response = await ReservationsService.all();
      let reservations = response.data;
      setReservations(reservations);
    } catch (error) {
      if (error.response?.status !== 401) console.error(error);
    }
  };

  const getOrders = async () => {
    try {
      const response = await OrderService.get();
      let orders = response.data.data;
      setOrders(orders);
    } catch (error) {
      if (error.response?.status !== 401) console.error(error);
    }
  };

  const truncateText = (text, wordLimit = 8) => {
    if (!text) return '';
    const words = text.split(' ');
    return words.length > wordLimit ? words.slice(0, wordLimit).join(' ') + '...' : text;
  };

  const checkLoginStatus = async () => {
    try {
      const response = await ProfileService.me();

      if (response) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    } catch (error) {
      console.error('Errore nella verifica del login:', error);
      setIsLoggedIn(false);
    }
  };

  const loadEvents = async () => {
    try {
      const {
        data: { data: eventsData },
      } = await EventService.get();
      setEvents(eventsData || []);
    } catch (error) {
      console.error(error);
    }
  };

  const slideOpts = {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    initialSlide: 1,
    speed: 400,
  };

  const eventSlideOpts = {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: { clickable: true },
    breakpoints: {
      480: { slidesPerView: 1.5 },
      640: { slidesPerView: 2 },
      768: { slidesPerView: 2.5 },
      1024: { slidesPerView: 3 },
    },
  };

  // Dal Task 17 l'annullamento è logico e `find` restituisce anche le prenotazioni
  // annullate: senza filtro il contatore le conterebbe e il cliente che ha appena
  // annullato leggerebbe ancora "1 Prenotazioni".
  const activeReservations = reservations.filter((r) => r.status !== 'cancelled');

  // Process events for display - similar to DesktopHomePage
  const eventsWithDates = events.reduce((acc, event) => {
    const uniqueDates = Array.from(new Set(event.availabilities ? event.availabilities.map((a) => a.start_at) : []));
    uniqueDates.forEach((start_at) => {
      const date = new Date(start_at);
      acc.push({
        ...event,
        displayDate: date.toLocaleDateString('it-IT'),
        rawDate: date,
        formattedDate: `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`,
      });
    });
    return acc;
  }, []);

  return (
    <>
      <HomeHeader
        options={options}
        selected={selected}
        saveShop={saveShop}
        shops={shops}
        history={history}
        slot={slot}
        fpsConfigs={fpsConfigs}
      />

      <IonContent id="homepage" className="ion-no-padding">
        {/* {options?.home_image && options?.shop_name && (
          <HomeImg
            homeImage={`${options.home_image}?v=${version}`}
            shopName={options.shop_name}
            className="card-slider-home"
          />
        )} */}

        {slides && slides.length > 0 && (
          <FadeSlider delay={8000} speed={1000} className="height">
            {slides?.map(
              (slide, index) =>
                slide.image.length > 0 && (
                  <IonCard key={index} color="" className="card-slider-home card-wrapper ion-no-padding">
                    {slide.url?.trim() && slide.url.trim() !== '#' ? (
                      <a href={slide.url} className="image-home">
                        <img alt={slide.alt ?? ''} src={slide.image} className="img-width img-max" />
                      </a>
                    ) : (
                      <div className="image-home">
                        <img alt={slide.alt ?? ''} src={slide.image} className="img-width img-max" />
                      </div>
                    )}
                  </IonCard>
                )
            )}
          </FadeSlider>
        )}

        <IonCard color="light" className="welcome-card">
          <IonCardHeader className="pd-bottom">
            {/* Titolo della home (home_title) mostrato con lo stile di un h1 */}
            <h2 className="m-top-zero home-card-title">{options?.home_title || options?.shop_name}</h2>
          </IonCardHeader>

          <IonCardContent>
            <div className="contact-info ">
              <p className="fontP ion-no-margin">
                <span onClick={() => openCall()}>
                  <IonIcon icon={call} className="icon-medium" />
                  {options?.call_number}
                </span>

                <span onClick={() => openChat()}>
                  <IonIcon icon={whatsapp} className="icon-medium" />
                  {options?.whatsapp_number}
                </span>

                {options?.facebook && (
                  <span onClick={() => openFacebook()}>
                    <IonIcon icon={logoFacebook} className="icon-medium social-icon" />
                  </span>
                )}
                {options?.instagram && (
                  <span onClick={() => openInstagram()}>
                    <IonIcon icon={logoInstagram} className="icon-medium social-icon" />
                  </span>
                )}
                {options?.site_url && (
                  <span onClick={() => openWebsite()}>
                    <IonIcon icon={globeOutline} className="icon-medium social-icon" />
                  </span>
                )}
              </p>

              <p className="fontP ion-no-margin">
                <IonIcon icon={time} className="icon-medium" />
                {options?.open_on}
              </p>

              {options?.home_text && (
                <p className="fontP ion-no-margin home-card-text" style={{ color: options?.home_text_color || undefined }}>
                  {options.home_text}
                </p>
              )}
            </div>
          </IonCardContent>
        </IonCard>

        <IonGrid className="m-buttons m-top pd-top">
          <IonRow>
            {fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && (
              <>
                {prescriptionsEnabled && (
                  <IonCol onClick={() => history.push('/app/prescription')}>
                    <IonTabButton className="service-item purple">
                      <IonIcon icon={medkit} />
                    </IonTabButton>
                    <p className="fontPBotton">Ricette</p>
                  </IonCol>
                )}

                <IonCol onClick={() => history.push('/app/category')}>
                  <IonTabButton className="service-item yellow">
                    <IonIcon icon={list} />
                  </IonTabButton>
                  <p className="fontPBotton">Prodotti</p>
                </IonCol>
              </>
            )}

            {fpsConfigs?.prescription_request > 0 && prescriptionsEnabled && (
              <IonCol onClick={() => history.push('/app/prescription-request')}>
                <IonTabButton className="service-item purple">
                  <IonIcon icon={medkit} />
                </IonTabButton>
                <p className="fontPBotton">Invia Ricetta</p>
              </IonCol>
            )}

            {fpsConfigs?.services > 0 && (
              <>
                <IonCol onClick={() => history.push('/app/services')}>
                  <IonTabButton className="service-item blue">
                    <IonIcon icon={calendarClear} />
                  </IonTabButton>
                  <p className="fontPBotton">Prenota</p>
                </IonCol>

                {fpsConfigs?.rentals > 0 && (
                  <IonCol onClick={() => history.push('/app/rentals')}>
                    <IonTabButton className="service-item green">
                      <IonIcon icon={rentalIcon} />
                    </IonTabButton>
                    <p className="fontPBotton">Noleggio</p>
                  </IonCol>
                )}

                {fpsConfigs?.vaccines > 0 && (
                  <IonCol onClick={() => history.push('/app/vaccini')}>
                    <IonTabButton className="service-item teal">
                      <IonIcon icon={vaccineIcon} />
                    </IonTabButton>
                    <p className="fontPBotton">Vaccini</p>
                  </IonCol>
                )}

                {events && events.length > 0 && (
                  <IonCol onClick={() => history.push('/app/events')}>
                    <IonTabButton className="service-item coral">
                      <IonIcon icon={calendarNumber} />
                    </IonTabButton>
                    <p className="fontPBotton">Eventi</p>
                  </IonCol>
                )}
              </>
            )}
          </IonRow>
        </IonGrid>

        {options?.chatbot === '1' && (
          <IonCard className="chatbot-card" href="/app/faq">
            <IonCardContent href="/app/faq">
              <div className="chatbot-content">
                <div className="chatbot-icon-container">
                  <IonIcon icon={chatbubbleEllipses} className="chatbot-icon"></IonIcon>
                </div>

                <div className="chatbot-text">
                  <h3>Assistente Virtuale</h3>
                  <p>Chiedi informazioni o assistenza</p>
                </div>
              </div>
            </IonCardContent>
          </IonCard>
        )}

        {/* Orders & Reservations */}
        <div className="section-header">
          <h2>
            {fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && fpsConfigs?.services > 0
              ? 'Ordini & Prenotazioni'
              : fpsConfigs?.products > 0 && options?.buy_products_in_app === '1'
                ? 'Ordini'
                : fpsConfigs?.services > 0
                  ? 'Prenotazioni'
                  : ''}
          </h2>
        </div>

        <IonGrid className="ion-no-padding ion-no-margin">
          <IonRow className="stat-card-row">
            {fpsConfigs?.services > 0 && (
              <IonCol>
                <IonCard className="stat-card yellow-bg mg-r-t">
                  <IonRow
                    className="card-row"
                    onClick={() => history.push(isLoggedIn ? '/app/reservations' : '/auth/login')}
                  >
                    <IonCol>
                      <h3>Prenotazioni</h3>
                    </IonCol>

                    <IonCol className="pd">
                      <IonCardContent lines="none" className="border">
                        <span>{isLoggedIn ? `${activeReservations.length} Prenotazioni` : 'Accedi'}</span>
                      </IonCardContent>
                    </IonCol>
                  </IonRow>
                </IonCard>
              </IonCol>
            )}

            {fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && (
              <IonCol>
                <IonCard className="stat-card coral-bg mg-l-t ">
                  <IonRow className="card-row" onClick={() => history.push(isLoggedIn ? '/app/orders' : '/auth/login')}>
                    <IonCol>
                      <h3>{isLoggedIn ? 'Ordine in corso' : 'Ordini'}</h3>
                    </IonCol>

                    <IonCol className="pd">
                      <IonCardContent lines="none" className="border">
                        <span>{isLoggedIn ? `${orders.length} Ordini` : 'Accedi'}</span>
                      </IonCardContent>
                    </IonCol>
                  </IonRow>
                </IonCard>
              </IonCol>
            )}

            {fpsConfigs?.prescription_request > 0 && prescriptionsEnabled && (
              <IonCol>
                <IonCard className="stat-card purple-bg mg-l-t ">
                  <IonRow
                    className="card-row"
                    onClick={() => history.push(isLoggedIn ? '/app/prescription-request' : '/auth/login')}
                  >
                    <IonCol>
                      <h3>Ricette</h3>
                    </IonCol>

                    <IonCol className="pd">
                      <IonCardContent lines="none" className="border">
                        <span>Invia ricetta</span>
                      </IonCardContent>
                    </IonCol>
                  </IonRow>
                </IonCard>
              </IonCol>
            )}
          </IonRow>
        </IonGrid>

        {fpsConfigs?.services > 0 && (
          <>
            <div className="section-header">
              <h2 className="m-top">Servizi in evidenza</h2>
            </div>

            <IonSlides pager={true} options={slideOpts}>
              {select_service.map((service) => (
                <IonSlide
                  key={service.id}
                  className="ion-no-padding"
                  onClick={() => history.push(`/app/reservations/${service.id}`)}
                >
                  <IonCard color="light" className="card-slider card-wrapper">
                    <IonCardTitle>
                      <h3>{service.name}</h3>
                    </IonCardTitle>

                    <IonCardContent className="ion-padding text">
                      <p>{truncateText(service.description.replace(/<[^>]+>/g, ''))}</p>

                      <p className="text fontP" color="dark">
                        Prezzo: {service.price} €
                      </p>
                    </IonCardContent>

                    <IonButton href={`/app/reservations/${service.id}`} color="dark" fill="clear">
                      Prenota !
                    </IonButton>
                  </IonCard>
                </IonSlide>
              ))}
            </IonSlides>
          </>
        )}

        {/* Events Slider */}
        {fpsConfigs?.services > 0 && eventsWithDates.length > 0 && (
          <>
            <div className="section-header">
              <h2 className="m-top">Eventi in programma</h2>
              <IonButton fill="clear" color="primary" size="small" onClick={() => history.push('/app/events')}>
                Tutti gli eventi
              </IonButton>
            </div>

            <IonSlides pager={true} options={eventSlideOpts} className="events-slider">
              {eventsWithDates.slice(0, 6).map((event, index) => (
                <IonSlide key={`${event.id}-${index}`}>
                  <div
                    className="dhp-event-card"
                    onClick={() => history.push(`/app/events/${event.id}/${event.formattedDate}`)}
                  >
                    <div className="dhp-event-date-badge">
                      <span className="dhp-event-day">{event.rawDate.getDate()}</span>
                      <span className="dhp-event-month">
                        {event.rawDate.toLocaleDateString('it-IT', { month: 'short' }).toUpperCase()}
                      </span>
                    </div>

                    <div className="dhp-event-info">
                      <h3>{event.name}</h3>
                      <p>{event.displayDate}</p>
                    </div>

                    <IonButton size="small" fill="outline" color="primary">
                      Scopri
                    </IonButton>
                  </div>
                </IonSlide>
              ))}
            </IonSlides>
          </>
        )}

        <IonGrid className="m-buttons m-bottom m-top pd-top">
          {(() => {
            let count = 0;
            if (options?.turni) count++;
            if (fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && options?.galenica === '1') count++;
            if (!!card) count++;

            const isSingle = count === 1;

            return (
              <IonRow className={isSingle ? 'ion-justify-content-center w-100' : ''}>
                {options?.turni && (
                  <IonCol className={isSingle ? 'custom-col text-center' : ''}>
                    <IonTabButton
                      href="app/shift"
                      size="small"
                      className={isSingle ? 'service-item pink w-100' : 'service-item pink'}
                    >
                      <IonIcon icon={documentTextOutline} />
                    </IonTabButton>
                    <p className="fontPBotton">Turni</p>
                  </IonCol>
                )}

                {fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && options?.galenica === '1' && (
                  <IonCol className={isSingle ? 'custom-col text-center' : ''}>
                    <IonTabButton
                      size="default"
                      className={isSingle ? 'service-item light-yellow w-100' : 'service-item light-yellow'}
                      href="/app/galenica"
                    >
                      <IonIcon icon={flaskOutline} />
                    </IonTabButton>
                    <p className="fontPBotton w-100">Preparazione Galenica</p>
                  </IonCol>
                )}

                {!!card && (
                  <IonCol className={isSingle ? 'custom-col text-center' : ''}>
                    <IonTabButton
                      href="/app/fidelityCard"
                      size="small"
                      className={isSingle ? 'service-item light-blue w-100' : 'service-item light-blue'}
                    >
                      <IonIcon icon={journalOutline} />
                    </IonTabButton>
                    <p className="fontPBotton">FidelityCard</p>
                  </IonCol>
                )}
              </IonRow>
            );
          })()}
        </IonGrid>

        {!!options?.ecommerce_link && !!options?.ecommerce_logo && (
          <CertEcommerce
            ecommerceLink={`${options?.ecommerce_link}`}
            ecommerceLogo={`${options?.ecommerce_logo}?v=${version}`}
            shopName={options?.shop_name}
          />
        )}

        {/* Social Media Card */}
        {(options?.facebook || options?.instagram || options?.site_url) && (
          <IonCard className="social-card" color="light">
            <IonCardContent>
              <div className="social-card-content">
                <h3>Seguici sui social</h3>
                <p>Resta aggiornato su promozioni, eventi e novità</p>
                <div className="social-icons-container">
                  {options?.facebook && (
                    <span onClick={() => openFacebook()} className="social-icon-large">
                      <IonIcon icon={logoFacebook} className="icon-large" />
                    </span>
                  )}
                  {options?.instagram && (
                    <span onClick={() => openInstagram()} className="social-icon-large">
                      <IonIcon icon={logoInstagram} className="icon-large" />
                    </span>
                  )}
                  {options?.site_url && (
                    <span onClick={() => openWebsite()} className="social-icon-large">
                      <IonIcon icon={globeOutline} className="icon-large" />
                    </span>
                  )}
                </div>
              </div>
            </IonCardContent>
          </IonCard>
        )}

        {/* {options?.turni && (
          <IonCard>
            <IonCardContent>
              <div>
                <div>
                  <IonIcon icon={chatbubbleEllipses}></IonIcon>
                </div>
                <div>
                  <h3>Turni</h3>
                  <a href={`${process.env.REACT_APP_API}${options.turni}`}>Vai ai turni</a>
                </div>
              </div>
            </IonCardContent>
          </IonCard>
        )} */}
      </IonContent>
    </>
  );
};

export default HomePage;
